
/**进入守护页*/
import pageShouhuTpl from '../template/page-shouhu.tmpl';
import ShouHu from '../component/shouhulist/index';

class ShouHuPage {
	constructor(hostId,acid){
		this.hostId = hostId;
		this.acid = acid;
	}
	render(){
		let self = this;
        
        this.renderHTML();
        this.bindEvent();
       
    }
    renderHTML() {
        let self = this;
        let actInfo = UpAct.actData[self.acid]
        self.actInfo = actInfo;

        let html = pageShouhuTpl({
            actInfo: actInfo,
        });
        $('#wrap').html(html);

        let shouhuApp = new ShouHu({
        	wrap: ".page-content",
        	hostId: this.hostId,
        	acid: this.acid
        });
        shouhuApp.render();

    }
    bindEvent(){
        $('#wrap').delegate('.gohome','click',function(e){
            let target = e.currentTarget;
            $.channel.emit('goHome');

        });
        
    }

}
module.exports = ShouHuPage;


// WEBPACK FOOTER //
// ./js/view/shouhu.js